import { useEffect, useState } from 'react'
import { api } from './api'
import { Notice } from './ui'
import { Link } from './navigation'
import { SystemLayout } from './SystemAdmins'
import { GoogleIdentitySetup } from './GoogleIdentitySetup'
import './google-setup-tabs.css'

export function GoogleSetupPage() {
  const [configured, setConfigured] = useState<boolean | null>(null)
  const [error, setError] = useState('')
  const load = async () => {
    setError('')
    try {
      const data = await api<{ connections: { issuer?: string; status: string }[] }>('/api/v1/company/overview', { signal: AbortSignal.timeout(20000) })
      setConfigured(data.connections.some(c => c.issuer === 'https://accounts.google.com' && c.status === 'active'))
    } catch { setError('We could not load Google setup. A company admin may need to set it up.') }
  }
  useEffect(() => { void load() }, [])
  return <SystemLayout active="google-setup">
    <div className="google-setup-page">
      <div className="page-heading"><div><h1>Google registration</h1><p>Lets people sign in with Google and link their Google accounts.</p></div></div>
      <p className="google-folder-pointer">Sharing folders with a team? Use <a href="/system/folder-access">Team folders</a>.</p>
      {error ? <><Notice tone="error">{error}</Notice><button className="button secondary" onClick={() => { void load() }}>Try again</button></> : configured === null ? <p role="status">Loading Google setup…</p> : <>
        <GoogleIdentitySetup configured={configured} onConfigured={load} />
        <section className="section-card google-purpose-card" aria-labelledby="google-next-title">
          <h2 id="google-next-title">Google Drive for apps</h2>
          <p>Drive access does not use this registration. Each substrate gets its own Google service account key.</p>
          <Link className="button secondary" to="/system/google-drive">Set up Google Drive</Link>
        </section>
      </>}
    </div>
  </SystemLayout>
}
